import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./index.css";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import contactHeroBgImg from "../assests/ContactImage/contactHeroBgImg.png";
import section2img from "../assests/HomeImg/section2-img.svg";

import CorporateHQImg from "../assests/ContactImage/CorporateHQImg.png";
import RegisteredOfficeimg from "../assests/ContactImage/RegisteredOfficeimg.png";


import QuarterlyTickCircleIcons from "../assests/ContactImage/QuarterlyTickCircleIcons.svg";
import InvestorRelationsBgImage from "../assests/ContactImage/InvestorRelationsBgImage.png";
import BusinessEnquiriesIcon from "../assests/ContactImage/BusinessEnquiriesIcon.svg";
import APISourcingIcon from "../assests/ContactImage/APISourcingIcon.svg";
import CDMOServicesIcon from "../assests/ContactImage/CDMOServicesIcon.svg";
import Distribution from "../assests/ContactImage/Distribution.svg";
import RegulatorySupportIcon from "../assests/ContactImage/RegulatorySupportIcon.svg";
import InvestorRelationsIcon from "../assests/ContactImage/InvestorRelationsIcon.png";
import PressReleasesIcon from "../assests/ContactImage/PressReleasesIcon.svg";
import PressKitIcon from "../assests/ContactImage/PressKitIcon.svg";
import ExecutiveProfilesIcon from "../assests/ContactImage/ExecutiveProfilesIcon.svg";
import CorporateFactsIcon from "../assests/ContactImage/CorporateFactsIcon.svg";



const PIN_ICON = (
    <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
);

const PHONE_ICON = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M14.6665 11.28V13.28C14.6672 13.4657 14.6292 13.6494 14.5548 13.8195C14.4804 13.9897 14.3713 14.1424 14.2345 14.2679C14.0977 14.3934 13.9362 14.489 13.7603 14.5485C13.5844 14.6079 13.398 14.63 13.2131 14.6133C11.1617 14.3904 9.19113 13.6894 7.45979 12.5667C5.84901 11.5431 4.48335 10.1774 3.45979 8.56665C2.33311 6.82745 1.63195 4.84731 1.41313 2.78665C1.39647 2.60229 1.41838 2.41649 1.47746 2.24107C1.53654 2.06564 1.63151 1.90444 1.7563 1.76773C1.8811 1.63102 2.033 1.52179 2.20232 1.447C2.37164 1.37221 2.55469 1.33349 2.73979 1.33332H4.73979C5.06333 1.33013 5.37699 1.4447 5.6223 1.65567C5.86761 1.86664 6.02784 2.15961 6.07313 2.47998C6.15754 3.12003 6.31409 3.74847 6.53979 4.35332C6.62949 4.59193 6.6489 4.85126 6.59573 5.10057C6.54256 5.34988 6.41903 5.57872 6.23979 5.75998L5.39313 6.60665C6.34216 8.27568 7.7241 9.65761 9.39313 10.6067L10.2398 9.75998C10.4211 9.58074 10.6499 9.45722 10.8992 9.40405C11.1485 9.35088 11.4078 9.37029 11.6465 9.45998C12.2513 9.68568 12.8797 9.84224 13.5198 9.92665C13.8436 9.97234 14.1394 10.1355 14.3508 10.385C14.5622 10.6345 14.6746 10.953 14.6665 11.28Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

const MAIL_ICON = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M13.3335 2.66669H2.66683C1.93045 2.66669 1.3335 3.26364 1.3335 4.00002V12C1.3335 12.7364 1.93045 13.3334 2.66683 13.3334H13.3335C14.0699 13.3334 14.6668 12.7364 14.6668 12V4.00002C14.6668 3.26364 14.0699 2.66669 13.3335 2.66669Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14.6668 4.66663L8.68683 8.46663C8.48101 8.59558 8.24304 8.66397 8.00016 8.66397C7.75729 8.66397 7.51932 8.59558 7.3135 8.46663L1.3335 4.66663" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

const MAP_ICON = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M13.3332 6.66665C13.3332 9.99531 9.6405 13.462 8.4005 14.5326C8.28499 14.6195 8.14437 14.6665 7.99984 14.6665C7.85531 14.6665 7.71469 14.6195 7.59917 14.5326C6.35917 13.462 2.6665 9.99531 2.6665 6.66665C2.6665 5.25216 3.22841 3.8956 4.2286 2.89541C5.2288 1.89522 6.58535 1.33331 7.99984 1.33331C9.41433 1.33331 10.7709 1.89522 11.7711 2.89541C12.7713 3.8956 13.3332 5.25216 13.3332 6.66665Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M8 8.66669C9.10457 8.66669 10 7.77126 10 6.66669C10 5.56212 9.10457 4.66669 8 4.66669C6.89543 4.66669 6 5.56212 6 6.66669C6 7.77126 6.89543 8.66669 8 8.66669Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

const HOME_ICON = (
    <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="#6B7280" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
    </svg>
);

const API_ICON = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.77 3.77z" />
    </svg>
);

const CDMO_ICON = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M3 21h18M3 7v1a3 3 0 0 0 6 0V7m0 1a3 3 0 0 0 6 0V7m0 1a3 3 0 0 0 6 0V7H3z" />
        <path d="M21 21V7h-1.5M3 21V7h1.5M10.5 7V3h3v4" />
    </svg>
);

const REGULATORY_ICON = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
);

const DISTRIBUTION_ICON = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
        <line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
);

const BD_ICON = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M12.1135 18.0716C12.1452 18.1505 12.2002 18.2179 12.2712 18.2646C12.3423 18.3113 12.4259 18.3352 12.5109 18.333C12.5959 18.3308 12.6781 18.3027 12.7467 18.2524C12.8152 18.2021 12.8668 18.1321 12.8943 18.0516L18.311 2.2183C18.3377 2.14446 18.3428 2.06455 18.3257 1.98793C18.3086 1.9113 18.27 1.84113 18.2145 1.78561C18.159 1.7301 18.0888 1.69154 18.0122 1.67446C17.9356 1.65737 17.8557 1.66246 17.7818 1.68913L1.9485 7.1058C1.86808 7.13338 1.79802 7.1849 1.74772 7.25344C1.69743 7.32199 1.66931 7.40428 1.66713 7.48926C1.66495 7.57425 1.68883 7.65787 1.73555 7.7289C1.78226 7.79993 1.84959 7.85497 1.9285 7.88663L8.53683 10.5366C8.74574 10.6203 8.93554 10.7453 9.0948 10.9043C9.25406 11.0633 9.37948 11.2529 9.4635 11.4616L12.1135 18.0716Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M18.2119 1.78918L9.09521 10.905" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

const LINKEDIN_ICON = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M10.6665 5.33337C11.7274 5.33337 12.7448 5.7548 13.4949 6.50495C14.2451 7.25509 14.6665 8.27251 14.6665 9.33337V14H11.9998V9.33337C11.9998 8.97975 11.8594 8.64061 11.6093 8.39057C11.3593 8.14052 11.0201 8.00004 10.6665 8.00004C10.3129 8.00004 9.97374 8.14052 9.7237 8.39057C9.47365 8.64061 9.33317 8.97975 9.33317 9.33337V14H6.6665V9.33337C6.6665 8.27251 7.08793 7.25509 7.83808 6.50495C8.58822 5.7548 9.60564 5.33337 10.6665 5.33337Z" stroke="#0077B5" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M4.00016 6H1.3335V14H4.00016V6Z" stroke="#0077B5" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2.66683 4.00004C3.40321 4.00004 4.00016 3.40309 4.00016 2.66671C4.00016 1.93033 3.40321 1.33337 2.66683 1.33337C1.93045 1.33337 1.3335 1.93033 1.3335 2.66671C1.3335 3.40309 1.93045 4.00004 2.66683 4.00004Z" stroke="#0077B5" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

const ARROW_RIGHT = (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="5" y1="12" x2="19" y2="12" />
        <polyline points="12 5 19 12 12 19" />
    </svg>
);

const BRIEFCASE_ICON = (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
);

const CHART_ICON = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M14.6668 4.66663L9.00016 10.3333L5.66683 6.99996L1.3335 11.3333" stroke="#003D7A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10.6665 4.66663H14.6665V8.66663" stroke="#003D7A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);



const BUILDING_ICON = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M4 14.6666V2.66659C4 2.31296 4.14048 1.97382 4.39052 1.72378C4.64057 1.47373 4.97971 1.33325 5.33333 1.33325H10.6667C11.0203 1.33325 11.3594 1.47373 11.6095 1.72378C11.8595 1.97382 12 2.31296 12 2.66659V14.6666H4Z" stroke="#003D7A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M4.00016 8H2.66683C2.31321 8 1.97407 8.14048 1.72402 8.39052C1.47397 8.64057 1.3335 8.97971 1.3335 9.33333V13.3333C1.3335 13.687 1.47397 14.0261 1.72402 14.2761C1.97407 14.5262 2.31321 14.6667 2.66683 14.6667H4.00016" stroke="#003D7A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12 6H13.3333C13.687 6 14.0261 6.14048 14.2761 6.39052C14.5262 6.64057 14.6667 6.97971 14.6667 7.33333V13.3333C14.6667 13.687 14.5262 14.0261 14.2761 14.2761C14.0261 14.5262 13.687 14.6667 13.3333 14.6667H12" stroke="#003D7A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6.6665 4H9.33317" stroke="#003D7A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6.6665 6.66675H9.33317" stroke="#003D7A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6.6665 9.33325H9.33317" stroke="#003D7A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6.6665 12H9.33317" stroke="#003D7A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

const DOWNLOAD_ICON = (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
);

const MEDIA_ICON = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M12.5002 15H8.3335" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M15.0002 11.6667H8.3335" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M3.33317 18.3334H16.6665C17.1085 18.3334 17.5325 18.1578 17.845 17.8453C18.1576 17.5327 18.3332 17.1088 18.3332 16.6667V3.33341C18.3332 2.89139 18.1576 2.46746 17.845 2.1549C17.5325 1.84234 17.1085 1.66675 16.6665 1.66675H6.6665C6.22448 1.66675 5.80055 1.84234 5.48799 2.1549C5.17543 2.46746 4.99984 2.89139 4.99984 3.33341V16.6667C4.99984 17.1088 4.82424 17.5327 4.51168 17.8453C4.19912 18.1578 3.7752 18.3334 3.33317 18.3334ZM3.33317 18.3334C2.89114 18.3334 2.46722 18.1578 2.15466 17.8453C1.8421 17.5327 1.6665 17.1088 1.6665 16.6667V9.16675C1.6665 8.72472 1.8421 8.3008 2.15466 7.98824C2.46722 7.67568 2.89114 7.50008 3.33317 7.50008H4.99984" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14.1668 5H9.16683C8.70659 5 8.3335 5.3731 8.3335 5.83333V7.5C8.3335 7.96024 8.70659 8.33333 9.16683 8.33333H14.1668C14.6271 8.33333 15.0002 7.96024 15.0002 7.5V5.83333C15.0002 5.3731 14.6271 5 14.1668 5Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

const MediaCommunications_ICON = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_468_10943)">
            <path d="M9.99984 12H6.6665" stroke="#C62828" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.9998 9.33325H6.6665" stroke="#C62828" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2.66683 14.6666H13.3335C13.6871 14.6666 14.0263 14.5261 14.2763 14.2761C14.5264 14.026 14.6668 13.6869 14.6668 13.3333V2.66659C14.6668 2.31296 14.5264 1.97382 14.2763 1.72378C14.0263 1.47373 13.6871 1.33325 13.3335 1.33325H5.3335C4.97987 1.33325 4.64074 1.47373 4.39069 1.72378C4.14064 1.97382 4.00016 2.31296 4.00016 2.66659V13.3333C4.00016 13.6869 3.85969 14.026 3.60964 14.2761C3.35959 14.5261 3.02045 14.6666 2.66683 14.6666ZM2.66683 14.6666C2.31321 14.6666 1.97407 14.5261 1.72402 14.2761C1.47397 14.026 1.3335 13.6869 1.3335 13.3333V7.33325C1.3335 6.97963 1.47397 6.64049 1.72402 6.39044C1.97407 6.14039 2.31321 5.99992 2.66683 5.99992H4.00016" stroke="#C62828" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.3332 4H7.33317C6.96498 4 6.6665 4.29848 6.6665 4.66667V6C6.6665 6.36819 6.96498 6.66667 7.33317 6.66667H11.3332C11.7014 6.66667 11.9998 6.36819 11.9998 6V4.66667C11.9998 4.29848 11.7014 4 11.3332 4Z" stroke="#C62828" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_468_10943">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const PRESS_KIT_ICON = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
);

const PROFILE_ICON = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
);

const FACTS_ICON = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M3 3h18v18H3z" />
        <path d="M3 9h18" />
        <path d="M3 15h18" />
        <path d="M9 3v18" />
        <path d="M15 3v18" />
    </svg>
);

const UPLOAD_ICON = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="17 8 12 3 7 8" />
        <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
);

const CHEVRON_DOWN_ICON = (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

const offices = [
    {
        badge: "Registered Corporate HQ",
        badgeColor: "rgba(27, 94, 32, 0.80)",
        themeColor: "#1B5E20",
        hoverBg: "rgba(27, 94, 32, 0.12)",
        image: CorporateHQImg,
        overlayTitle: "Registered Head Office - India",
        name: "Viyash Scientific Limited",
        address: "Registered Office: Plot No. 290, Srivaili's Corporate, Road No. 6, Madhapur, Hyderabad - 500081, Telangana State, India.",
        phone: "+91 40 2363 5000",
        email: "info@viyash.com",
        mapLink: "#",
        mapBorderColor: "#1B5E20",
        mapTextColor: "#1B5E20",
    },
    {
        badge: "Alivira",
        badgeColor: "rgba(27, 94, 32, 0.80)",
        themeColor: "#1B5E20",
        hoverBg: "rgba(27, 94, 32, 0.12)",
        image: CorporateHQImg,
        overlayTitle: "Viyash Scientific Thane office",
        name: "Viyash Scientific  and Alivira Animal Health Ltd.",
        address: "301, 3rd Floor, Dosti Pinnacle, Plot No. E7, Road No.22 Wagle Industrial Estate, Thane (W), Mumbai – 400 604",
        phone: "+91 22 68534777",
        email: "info@viyash.com",
        mapLink: "https://www.google.com/maps?cid=18380540984102061967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAEYASAB&hl=en-GB&source=embed",
        mapBorderColor: "#1B5E20",
        mapTextColor: "#1B5E20",
    },

    {
        badge: "R&D Center",
        badgeColor: "rgba(0, 61, 122, 0.80)",
        themeColor: "#01589B",
        hoverBg: "rgba(1, 88, 155, 0.1)",
        image: RegisteredOfficeimg,
        overlayTitle: "R&D Center",
        name: "Viyash Scientific Limited",
        address: "R&D Center: Plot No. 80/A, Phase - I, IDA Jeedimetla, Quthbullapur, Medchal - Malkajgiri (Dist.) - 500055, Telangana State, India.",
        phone: "+91 40 2363 5000",
        email: "info@viyash.com",
        mapLink: "https://maps.app.goo.gl/oNxg9QeW6FDUAUWA8",
        mapBorderColor: "#003D7A",
        mapTextColor: "#003D7A",
    },

];

const Contact = () => {
    const [phone, setPhone] = useState("");
    const [formData, setFormData] = useState({
        fullName: "",
        company: "",
        email: "",
        country: "",
        enquiryType: "",
        subject: "",
        message: "",
    });
    const [fileName, setFileName] = useState("");
    const [fileData, setFileData] = useState(null); // Added state to store actual file object
    const [errors, setErrors] = useState({});
    const [formStatus, setFormStatus] = useState("idle");

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: "" }));
        }
    };

    const handlePhoneChange = (val) => {
        setPhone(val);
        if (errors.phone) {
            setErrors(prev => ({ ...prev, phone: "" }));
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB limit

            if (file.size > MAX_FILE_SIZE) {
                setErrors(prev => ({ ...prev, document: "File size must be strictly less than 5MB" }));
                e.target.value = null; // Clear the input visually
                setFileName("");
                setFileData(null);
                return;
            }

            setFileName(file.name);
            setFileData(file); // Store the actual file for the API payload
            if (errors.document) {
                setErrors(prev => ({ ...prev, document: "" }));
            }
        } else {
            setFileName("");
            setFileData(null);
        }
    };

    const validateForm = () => {
        const newErrors = {};

        // Full Name
        if (!formData.fullName.trim()) {
            newErrors.fullName = "Full name is required";
        }

        // Email
        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }

        // Phone
        if (!phone || !phone.trim()) {
            newErrors.phone = "Phone number is required";
        } else if (phone.replace(/\D/g, "").length < 10) {
            newErrors.phone = "Invalid phone number";
        }

        // Country
        if (!formData.country) {
            newErrors.country = "Country is required";
        }

        // Enquiry Type
        if (!formData.enquiryType) {
            newErrors.enquiryType = "Enquiry type is required";
        }

        // Subject
        if (!formData.subject.trim()) {
            newErrors.subject = "Subject is required";
        }

        // Message
        if (!formData.message.trim()) {
            newErrors.message = "Message is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setFormStatus("submitting");

        try {
            const payload = {
                fullName: formData.fullName.trim(),
                company: formData.company.trim(),
                email: formData.email.trim(),
                phoneNumber: phone,
                country: formData.country,
                etype: formData.enquiryType,
                subject: formData.subject.trim(),
                Message: formData.message.trim().replace(/[\r\n]+/g, " "),
            };

            const response = await fetch("https://viyash.whysocial.in/apis/getInTouch", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                // Read actual backend validation errors
                let errMsg = "Failed to submit the form. Please try again later.";
                try {
                    const errBody = await response.json();
                    if (errBody?.errors?.length) {
                        errMsg = errBody.errors.join("\n");
                    } else if (errBody?.message) {
                        errMsg = errBody.message;
                    }
                } catch (_) { }
                throw new Error(errMsg);
            }

            setFormStatus("success");

            // Reset form status back to normal after a brief delay
            setTimeout(() => {
                setFormStatus("idle");
                setFormData({
                    fullName: "",
                    company: "",
                    email: "",
                    country: "",
                    enquiryType: "",
                    subject: "",
                    message: "",
                });
                setPhone("");
                setFileName("");
                setFileData(null);
            }, 3000);

        } catch (error) {
            console.error(error);
            // Optionally, handle error status and notify the user
            alert(error.message);
            setFormStatus("idle");
        }
    };

    const countries = [
        { name: "Afghanistan", code: "AF" },
        { name: "Albania", code: "AL" },
        { name: "Algeria", code: "DZ" },
        { name: "Andorra", code: "AD" },
        { name: "Angola", code: "AO" },
        { name: "Antigua and Barbuda", code: "AG" },
        { name: "Argentina", code: "AR" },
        { name: "Armenia", code: "AM" },
        { name: "Australia", code: "AU" },
        { name: "Austria", code: "AT" },
        { name: "Azerbaijan", code: "AZ" },
        { name: "Bahamas", code: "BS" },
        { name: "Bahrain", code: "BH" },
        { name: "Bangladesh", code: "BD" },
        { name: "Barbados", code: "BB" },
        { name: "Belarus", code: "BY" },
        { name: "Belgium", code: "BE" },
        { name: "Belize", code: "BZ" },
        { name: "Benin", code: "BJ" },
        { name: "Bhutan", code: "BT" },
        { name: "Bolivia", code: "BO" },
        { name: "Bosnia and Herzegovina", code: "BA" },
        { name: "Botswana", code: "BW" },
        { name: "Brazil", code: "BR" },
        { name: "Brunei", code: "BN" },
        { name: "Bulgaria", code: "BG" },
        { name: "Burkina Faso", code: "BF" },
        { name: "Burundi", code: "BI" },
        { name: "Cabo Verde", code: "CV" },
        { name: "Cambodia", code: "KH" },
        { name: "Cameroon", code: "CM" },
        { name: "Canada", code: "CA" },
        { name: "Central African Republic", code: "CF" },
        { name: "Chad", code: "TD" },
        { name: "Chile", code: "CL" },
        { name: "China", code: "CN" },
        { name: "Colombia", code: "CO" },
        { name: "Comoros", code: "KM" },
        { name: "Congo (Congo-Brazzaville)", code: "CG" },
        { name: "Costa Rica", code: "CR" },
        { name: "Croatia", code: "HR" },
        { name: "Cuba", code: "CU" },
        { name: "Cyprus", code: "CY" },
        { name: "Czechia (Czech Republic)", code: "CZ" },
        { name: "Denmark", code: "DK" },
        { name: "Djibouti", code: "DJ" },
        { name: "Dominica", code: "DM" },
        { name: "Dominican Republic", code: "DO" },
        { name: "Ecuador", code: "EC" },
        { name: "Egypt", code: "EG" },
        { name: "El Salvador", code: "SV" },
        { name: "Equatorial Guinea", code: "GQ" },
        { name: "Eritrea", code: "ER" },
        { name: "Estonia", code: "EE" },
        { name: "Eswatini", code: "SZ" },
        { name: "Ethiopia", code: "ET" },
        { name: "Fiji", code: "FJ" },
        { name: "Finland", code: "FI" },
        { name: "France", code: "FR" },
        { name: "Gabon", code: "GA" },
        { name: "Gambia", code: "GM" },
        { name: "Georgia", code: "GE" },
        { name: "Germany", code: "DE" },
        { name: "Ghana", code: "GH" },
        { name: "Greece", code: "GR" },
        { name: "Grenada", code: "GD" },
        { name: "Guatemala", code: "GT" },
        { name: "Guinea", code: "GN" },
        { name: "Guinea-Bissau", code: "GW" },
        { name: "Guyana", code: "GY" },
        { name: "Haiti", code: "HT" },
        { name: "Holy See", code: "VA" },
        { name: "Honduras", code: "HN" },
        { name: "Hungary", code: "HU" },
        { name: "Iceland", code: "IS" },
        { name: "India", code: "IN" },
        { name: "Indonesia", code: "ID" },
        { name: "Iran", code: "IR" },
        { name: "Iraq", code: "IQ" },
        { name: "Ireland", code: "IE" },
        { name: "Israel", code: "IL" },
        { name: "Italy", code: "IT" },
        { name: "Jamaica", code: "JM" },
        { name: "Japan", code: "JP" },
        { name: "Jordan", code: "JO" },
        { name: "Kazakhstan", code: "KZ" },
        { name: "Kenya", code: "KE" },
        { name: "Kiribati", code: "KI" },
        { name: "Kuwait", code: "KW" },
        { name: "Kyrgyzstan", code: "KG" },
        { name: "Laos", code: "LA" },
        { name: "Latvia", code: "LV" },
        { name: "Lebanon", code: "LB" },
        { name: "Lesotho", code: "LS" },
        { name: "Liberia", code: "LR" },
        { name: "Libya", code: "LY" },
        { name: "Liechtenstein", code: "LI" },
        { name: "Lithuania", code: "LT" },
        { name: "Luxembourg", code: "LU" },
        { name: "Madagascar", code: "MG" },
        { name: "Malawi", code: "MW" },
        { name: "Malaysia", code: "MY" },
        { name: "Maldives", code: "MV" },
        { name: "Mali", code: "ML" },
        { name: "Malta", code: "MT" },
        { name: "Marshall Islands", code: "MH" },
        { name: "Mauritania", code: "MR" },
        { name: "Mauritius", code: "MU" },
        { name: "Mexico", code: "MX" },
        { name: "Micronesia", code: "FM" },
        { name: "Moldova", code: "MD" },
        { name: "Monaco", code: "MC" },
        { name: "Mongolia", code: "MN" },
        { name: "Montenegro", code: "ME" },
        { name: "Morocco", code: "MA" },
        { name: "Mozambique", code: "MZ" },
        { name: "Myanmar (formerly Burma)", code: "MM" },
        { name: "Namibia", code: "NA" },
        { name: "Nauru", code: "NR" },
        { name: "Nepal", code: "NP" },
        { name: "Netherlands", code: "NL" },
        { name: "New Zealand", code: "NZ" },
        { name: "Nicaragua", code: "NI" },
        { name: "Niger", code: "NE" },
        { name: "Nigeria", code: "NG" },
        { name: "North Korea", code: "KP" },
        { name: "North Macedonia", code: "MK" },
        { name: "Norway", code: "NO" },
        { name: "Oman", code: "OM" },
        { name: "Pakistan", code: "PK" },
        { name: "Palau", code: "PW" },
        { name: "Palestine State", code: "PS" },
        { name: "Panama", code: "PA" },
        { name: "Papua New Guinea", code: "PG" },
        { name: "Paraguay", code: "PY" },
        { name: "Peru", code: "PE" },
        { name: "Philippines", code: "PH" },
        { name: "Poland", code: "PL" },
        { name: "Portugal", code: "PT" },
        { name: "Qatar", code: "QA" },
        { name: "Romania", code: "RO" },
        { name: "Russia", code: "RU" },
        { name: "Rwanda", code: "RW" },
        { name: "Saint Kitts and Nevis", code: "KN" },
        { name: "Saint Lucia", code: "LC" },
        { name: "Saint Vincent and the Grenadines", code: "VC" },
        { name: "Samoa", code: "WS" },
        { name: "San Marino", code: "SM" },
        { name: "Sao Tome and Principe", code: "ST" },
        { name: "Saudi Arabia", code: "SA" },
        { name: "Senegal", code: "SN" },
        { name: "Serbia", code: "RS" },
        { name: "Seychelles", code: "SC" },
        { name: "Sierra Leone", code: "SL" },
        { name: "Singapore", code: "SG" },
        { name: "Slovakia", code: "SK" },
        { name: "Slovenia", code: "SI" },
        { name: "Solomon Islands", code: "SB" },
        { name: "Somalia", code: "SO" },
        { name: "South Africa", code: "ZA" },
        { name: "South Korea", code: "KR" },
        { name: "South Sudan", code: "SS" },
        { name: "Spain", code: "ES" },
        { name: "Sri Lanka", code: "LK" },
        { name: "Sudan", code: "SD" },
        { name: "Suriname", code: "SR" },
        { name: "Sweden", code: "SE" },
        { name: "Switzerland", code: "CH" },
        { name: "Syria", code: "SY" },
        { name: "Tajikistan", code: "TJ" },
        { name: "Tanzania", code: "TZ" },
        { name: "Thailand", code: "TH" },
        { name: "Timor-Leste", code: "TL" },
        { name: "Togo", code: "TG" },
        { name: "Tonga", code: "TO" },
        { name: "Trinidad and Tobago", code: "TT" },
        { name: "Tunisia", code: "TN" },
        { name: "Turkey", code: "TR" },
        { name: "Turkmenistan", code: "TM" },
        { name: "Tuvalu", code: "TV" },
        { name: "Uganda", code: "UG" },
        { name: "Ukraine", code: "UA" },
        { name: "United Arab Emirates", code: "AE" },
        { name: "United Kingdom", code: "GB" },
        { name: "United States of America", code: "US" },
        { name: "Uruguay", code: "UY" },
        { name: "Uzbekistan", code: "UZ" },
        { name: "Vanuatu", code: "VU" },
        { name: "Venezuela", code: "VE" },
        { name: "Vietnam", code: "VN" },
        { name: "Yemen", code: "YE" },
        { name: "Zambia", code: "ZM" },
        { name: "Zimbabwe", code: "ZW" }
    ];

    return (
        <div className="contact-wrapper">

            {/* ================= CONTACT SECTION 1 ================= */}
            <section className="contact-section1">

                {/* Background Image */}
                <img
                    src={contactHeroBgImg}
                    alt="CDMO Background"
                    className="contact-section1-bg"
                />

                {/* Gradient Overlay */}
                <div className="contact-section1-overlay"></div>

                {/* Content */}
                <div className="contact-section1-content">

                    <h1 className="contact-section1-title">
                        Contact
                    </h1>

                    <p className="contact-section1-text">
                        Connecting Global Healthcare Through Science &amp; Integrity
                    </p>

                    <p className="contact-section1-text2">
                        For business enquiries, investor relations, media interactions, or corporate communications, reach out to the relevant team below.
                    </p>

                </div>

            </section>
            {/* ================= Breadcrumb ================= */}
            <div className="cdmo-breadcrumb-container">
                <div className="cdmo-breadcrumb-wrapper">

                    <Link to="/" className="cdmo-breadcrumb-link cdmo-home-link">
                        <svg className="cdmo-breadcrumb-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M10 14V8.66667C10 8.48986 9.92976 8.32029 9.80474 8.19526C9.67971 8.07024 9.51014 8 9.33333 8H6.66667C6.48986 8 6.32029 8.07024 6.19526 8.19526C6.07024 8.32029 6 8.48986 6 8.66667V14"
                                stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M2 6.66667C1.99995 6.47271 2.04222 6.28108 2.12386 6.10514C2.20549 5.92921 2.32453 5.7732 2.47267 5.648L7.13933 1.64867C7.37999 1.44527 7.6849 1.33368 8 1.33368C8.3151 1.33368 8.62001 1.44527 8.86067 1.64867L13.5273 5.648C13.6755 5.7732 13.7945 5.92921 13.8761 6.10514C13.9578 6.28108 14 6.47271 14 6.66667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V6.66667Z"
                                stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Home
                    </Link>

                    <span className="cdmo-breadcrumb-separator">›</span>

                    <span className="cdmo-breadcrumb-current">Contact</span>

                </div>
            </div>

            {/* ── OUR OFFICES ── */}
            <section className="contact-offices-section">
                {/* Header */}
                {/* Header */}
                <div className="cdmo-section2-header">

                    <h2>Our Offices</h2>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p>
                        Reach our corporate and registered offices for formal communications
                    </p>

                </div>

                {/* Office Cards Grid */}
                <div className="contact-offices-grid">
                    {offices.map((office) => (
                        <div key={office.badge} className="contact-office-card">

                            {/* Image with overlay */}
                            <div className="contact-office-image-wrapper">
                                <img
                                    src={office.image}
                                    alt={office.badge}
                                    className="contact-office-image"
                                />
                                <div className="contact-office-image-overlay" />
                                <div
                                    className="contact-office-badge"
                                    style={{ background: office.badgeColor }}
                                >
                                    {office.badge}
                                </div>
                                <div className="contact-office-overlay-title">
                                    {office.overlayTitle}
                                </div>
                            </div>

                            {/* Info body */}
                            <div className="contact-office-info">
                                {/* Company name + address */}
                                <div className="contact-office-item">
                                    <span className="contact-office-icon" style={{ color: office.themeColor }}>{PIN_ICON}</span>
                                    <div>
                                        <div className="contact-office-name">{office.name}</div>
                                        <div className="contact-office-address">{office.address}</div>
                                    </div>
                                </div>

                                {/* Phone */}
                                <div className="contact-office-item">
                                    <span className="contact-office-icon" style={{ color: office.themeColor }}>{PHONE_ICON}</span>
                                    <span className="contact-office-detail">{office.phone}</span>
                                </div>

                                {/* Email */}
                                <div className="contact-office-item">
                                    <span className="contact-office-icon" style={{ color: office.themeColor }}>{MAIL_ICON}</span>
                                    <a
                                        href={`mailto:${office.email}`}
                                        className="contact-office-link"
                                        style={{ color: office.themeColor }}
                                    >
                                        {office.email}
                                    </a>
                                </div>

                                {/* Google Maps button */}
                                <a
                                    href={office.mapLink}
                                    className="contact-office-map-btn"
                                    style={{
                                        border: `2px solid ${office.mapBorderColor}`,
                                        color: office.mapTextColor,
                                        "--hover-bg": office.hoverBg,
                                    }}
                                >
                                    <span style={{ color: office.mapTextColor, display: 'flex', alignItems: 'center' }}>{MAP_ICON}</span>
                                    View on Google Maps
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* ── Business Enquiries ── */}
            <section className="contact-business-section">
                <div className="contact-business-container">
                    {/* Left Column */}
                    <div className="contact-business-left">
                        <div className="contact-business-label-row">
                            <img src={BusinessEnquiriesIcon} alt="Business" className="contact-business-label-icon-img" />
                            <span className="contact-business-label-text">Business Enquiries</span>
                        </div>
                        <h2 className="contact-business-heading">Partner with Viyash</h2>
                        <p className="contact-business-description">
                            For <span className="text-bold">API sourcing</span>, <span className="text-bold">CDMO partnerships</span>, formulation development, regulatory collaborations, and global distribution enquiries, contact our Business Development team. We serve 250+ global customers across 150+ marketswith a portfolio of 75+ commercial APIs.
                        </p>

                        <div className="contact-services-grid">
                            <div className="contact-service-card">
                                <div className="contact-service-icon-bg">
                                    <img src={APISourcingIcon} alt="API Sourcing" className="contact-service-icon-img" />
                                </div>
                                <div className="contact-service-info">
                                    <div className="contact-service-title">API Sourcing</div>
                                    <div className="contact-service-subtitle">75+ commercial APIs, intermediates</div>
                                </div>
                            </div>
                            <div className="contact-service-card">
                                <div className="contact-service-icon-bg">
                                    <img src={CDMOServicesIcon} alt="CDMO" className="contact-service-icon-img" />
                                </div>
                                <div className="contact-service-info">
                                    <div className="contact-service-title">CDMO Services</div>
                                    <div className="contact-service-subtitle">Contract manufacturing & development</div>
                                </div>
                            </div>
                            <div className="contact-service-card">
                                <div className="contact-service-icon-bg">
                                    <img src={RegulatorySupportIcon} alt="Regulatory" className="contact-service-icon-img" />
                                </div>
                                <div className="contact-service-info">
                                    <div className="contact-service-title">Regulatory Support</div>
                                    <div className="contact-service-subtitle">DMFs, ANDAs, CEPs, dossiers</div>
                                </div>
                            </div>
                            <div className="contact-service-card">
                                <div className="contact-service-icon-bg">
                                    <img src={Distribution} alt="Distribution" className="contact-service-icon-img" />
                                </div>
                                <div className="contact-service-info">
                                    <div className="contact-service-title">Global Distribution</div>
                                    <div className="contact-service-subtitle">Global logistics & supply chain</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="contact-business-right">
                        <div className="business-team-card">
                            <div className="business-team-icon-wrapper">
                                {BD_ICON}
                            </div>
                            <h3 className="business-team-title">Business Development Team</h3>
                            <p className="business-team-subtitle">
                                Reach our BD team for commercial partnerships, sourcing agreements, and CDMO enquiries.
                            </p>

                            <div className="business-contact-list">
                                <div className="business-contact-item">
                                    <div className="business-contact-icon-bg">
                                        {MAIL_ICON}
                                    </div>
                                    <div className="business-contact-details">
                                        <div className="business-contact-label">Email</div>
                                        <div className="business-contact-value">info@viyash.com</div>
                                    </div>
                                </div>

                                <div className="business-contact-item">
                                    <div className="business-contact-icon-bg">
                                        {PHONE_ICON}
                                    </div>
                                    <div className="business-contact-details">
                                        <div className="business-contact-label">Phone</div>
                                        <div className="business-contact-value">+91 40 2363 5000</div>
                                    </div>
                                </div>

                                <div className="business-contact-item">
                                    <div className="business-contact-icon-bg">
                                        {LINKEDIN_ICON}
                                    </div>
                                    <div className="business-contact-details">
                                        <div className="business-contact-label">LinkedIn</div>
                                        <a href="https://www.linkedin.com/company/viyash-life-sciences-pvt-ltd/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="business-contact-link">
                                            https://www.linkedin.com/company/viyash-life-sciences-pvt-ltd/
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <button className="business-enquiry-btn" onClick={() => document.getElementById('contactForm')?.scrollIntoView({ behavior: 'smooth' })}>
                                Send Business Enquiry {ARROW_RIGHT}
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── Investor Relations ── */}
            <section className="contact-investor-section">
                <div className="contact-investor-container">
                    {/* Left Column - Card */}
                    <div className="contact-investor-left">
                        <div className="investor-team-card">
                            <div className="investor-team-header" style={{ backgroundImage: `url(${InvestorRelationsBgImage})` }}>
                                <div className="investor-team-icon-header">
                                    <img src={InvestorRelationsIcon} alt="Investor Relations" className="investor-team-icon-img" />
                                </div>
                                <h3 className="investor-team-title-white">Investor Relations</h3>
                                <p className="investor-team-subtitle-white">NSE · BSE Listed · SEBI Compliant Disclosures</p>
                            </div>

                            <div className="investor-team-content">
                                <p className="investor-team-description">
                                    For financial disclosures, governance matters, investor presentations, shareholder communications, or analyst briefings, contact our dedicated Investor Relations team.
                                </p>

                                <div className="investor-contact-list">
                                    <div className="investor-contact-card">
                                        <div className="business-contact-icon-bg">
                                            {MAIL_ICON}
                                        </div>
                                        <div className="business-contact-details">
                                            <div className="business-contact-label">IR Email</div>
                                            <div className="business-contact-value">info@viyash.com</div>
                                        </div>
                                    </div>

                                    <div className="investor-contact-card">
                                        <div className="business-contact-icon-bg">
                                            {PHONE_ICON}
                                        </div>
                                        <div className="business-contact-details">
                                            <div className="business-contact-label">IR Hotline</div>
                                            <div className="business-contact-value">+91 40 2363 5000</div>
                                        </div>
                                    </div>

                                    <div className="investor-contact-card">
                                        <div className="business-contact-icon-bg">
                                            {BUILDING_ICON}
                                        </div>
                                        <div className="business-contact-details">
                                            <div className="business-contact-label">Exchange</div>
                                            <div className="business-contact-value-black">NSE · BSE · ISIN: INE807F01027</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="investor-button-group">
                                    <button className="contact-ir-btn" onClick={() => document.getElementById('contactForm')?.scrollIntoView({ behavior: 'smooth' })}>Contact IR</button>
                                    {/* <button className="investor-pack-btn">
                                        {DOWNLOAD_ICON} Investor Pack
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Column - Content */}
                    <div className="contact-investor-right">
                        <div className="contact-business-label-row">
                            <span className="contact-business-label-icon">{CHART_ICON}</span>
                            <span className="contact-business-label-text">Investor Relations</span>
                        </div>
                        <h2 className="contact-business-heading">Shareholder & Analyst Communications</h2>
                        <p className="contact-business-description investor-maxWidth">
                            Viyash Scientific Limited maintains institutional-grade investor relations. Our IR team provides timely, transparent, and comprehensive financial communications in accordance with SEBI regulations and global best practices.
                        </p>

                        <ul className="investor-feature-list">
                            <li>
                                <img src={QuarterlyTickCircleIcons} alt="Tick" />
                                <span>Quarterly & Annual Financial Results</span>
                            </li>
                            <li>
                                <img src={QuarterlyTickCircleIcons} alt="Tick" />
                                <span>Investor Presentations & Roadshows</span>
                            </li>
                            <li>
                                <img src={QuarterlyTickCircleIcons} alt="Tick" />
                                <span>Annual Reports & BRSR Filings</span>
                            </li>
                            <li>
                                <img src={QuarterlyTickCircleIcons} alt="Tick" />
                                <span>Board Meeting Intimations</span>
                            </li>
                            <li>
                                <img src={QuarterlyTickCircleIcons} alt="Tick" />
                                <span>Merger & Strategic Announcements</span>
                            </li>
                        </ul>

                        <Link to="/investor-relation" className="visit-investors-link">
                            Visit Investor Relations Page {ARROW_RIGHT}
                        </Link>
                    </div>
                </div>
            </section>

            {/* ── Media & Communications ── */}
            <section className="contact-media-section">
                <div className="contact-media-container">
                    {/* Left Column - Grid */}
                    <div className="contact-media-left">
                        <div className="contact-media-label-row">
                            <span className="contact-media-label-icon">{MediaCommunications_ICON}</span>
                            <span className="contact-media-label-text">Media & Communications</span>
                        </div>
                        <h2 className="contact-business-heading">Media & Corporate Communications</h2>
                        <p className="contact-business-description">
                            For press releases, executive interviews, editorial coverage, brand communications, and corporate photography requests, reach out to our Corporate Communications team. We respond to media queries within 24 hours.
                        </p>

                        <div className="contact-services-grid">
                            <div className="contact-service-card">
                                <div className="contact-service-icon-bg media-icon-bg">
                                    <img src={PressReleasesIcon} alt="Press Releases" className="contact-service-icon-img" />
                                </div>
                                <div className="contact-service-info">
                                    <div className="contact-service-title">Press Releases</div>
                                    <div className="contact-service-subtitle">Latest corporate news</div>
                                </div>
                            </div>
                            <div className="contact-service-card">
                                <div className="contact-service-icon-bg media-icon-bg">
                                    <img src={PressKitIcon} alt="Press Kit" className="contact-service-icon-img" />
                                </div>
                                <div className="contact-service-info">
                                    <div className="contact-service-title">Press Kit</div>
                                    <div className="contact-service-subtitle">Brand assets & resources</div>
                                </div>
                            </div>
                            <div className="contact-service-card">
                                <div className="contact-service-icon-bg media-icon-bg">
                                    <img src={ExecutiveProfilesIcon} alt="Profiles" className="contact-service-icon-img" />
                                </div>
                                <div className="contact-service-info">
                                    <div className="contact-service-title">Executive Profiles</div>
                                    <div className="contact-service-subtitle">Leadership bios & photos</div>
                                </div>
                            </div>
                            <div className="contact-service-card">
                                <div className="contact-service-icon-bg media-icon-bg">
                                    <img src={CorporateFactsIcon} alt="Facts" className="contact-service-icon-img" />
                                </div>
                                <div className="contact-service-info">
                                    <div className="contact-service-title">Corporate Facts</div>
                                    <div className="contact-service-subtitle">Key metrics & history</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Column - Card */}
                    <div className="contact-media-right">
                        <div className="business-team-card">
                            <div className="business-team-icon-wrapper media-gradient-bg">
                                {MEDIA_ICON}
                            </div>
                            <h3 className="business-team-title">Communications Team</h3>
                            <p className="business-team-subtitle media-subtitle-width">
                                All media enquiries are handled by our Corporate Communications team. Response within 24 hrs on business days.
                            </p>

                            <div className="business-contact-list">
                                <div className="media-contact-card">
                                    <div className="business-contact-icon-bg media-icon-bg">
                                        {MAIL_ICON}
                                    </div>
                                    <div className="business-contact-details">
                                        <div className="business-contact-label">Media Email</div>
                                        <div className="media-contact-value">info@viyash.com</div>
                                    </div>
                                </div>

                                <div className="media-contact-card">
                                    <div className="business-contact-icon-bg media-icon-bg">
                                        {PHONE_ICON}
                                    </div>
                                    <div className="business-contact-details">
                                        <div className="business-contact-label">Media Line</div>
                                        <div className="media-contact-value">+91 40 2363 5000</div>
                                    </div>
                                </div>
                            </div>

                            <div className="media-button-group">
                                <button className="media-enquiry-btn" onClick={() => document.getElementById('contactForm')?.scrollIntoView({ behavior: 'smooth' })}>
                                    Media Enquiry {ARROW_RIGHT}
                                </button>
                                {/* <button className="media-presskit-btn">
                                    {DOWNLOAD_ICON} Press Kit
                                </button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── General Enquiry Form Section ── */}
            <div className="contact-touch-header" >
                <h2>Get in Touch</h2>
                <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                <p>All enquiries are acknowledged within 24 hours on business days</p>
            </div>

            <section className="contact-form-section" id="contactForm">
                <div className="contact-form-container">
                    <div className="contact-form-header">
                        <div className="form-header-title-row">
                            <img src={CDMOServicesIcon} alt="CDMO Services" className="form-header-icon" />
                            <div className="form-header-texts">
                                <h3 className="form-header-title">Viyash Scientific Limited — General Enquiry</h3>
                                <p className="form-header-subtitle">Fields marked * are mandatory</p>
                            </div>
                        </div>
                    </div>

                    <div className="contact-form-body">
                        <form className="general-enquiry-form" onSubmit={handleFormSubmit}>
                            <div className="form-grid"                                                                                                                                   >
                                <div className="form-group" Required>
                                    <label>Full Name *</label>
                                    <input type="text" name="fullName" value={formData.fullName} onChange={handleInputChange} placeholder="Your full name" />
                                    {errors.fullName && <span className="error-text">{errors.fullName}</span>}
                                </div>
                                <div className="form-group" Required>
                                    <label>Company Name</label>
                                    <input type="text" name="company" value={formData.company} onChange={handleInputChange} placeholder="Organisation / Company" />
                                </div>
                                <div className="form-group" Required>
                                    <label>Email Address *</label>
                                    <input type="email" name="email" value={formData.email} onChange={handleInputChange} placeholder="your@email.com" />
                                    {errors.email && <span className="error-text">{errors.email}</span>}
                                </div>
                                <div className="form-group" Required>
                                    <label>Phone Number *</label>
                                    <PhoneInput
                                        country={'in'}
                                        value={phone}
                                        onChange={handlePhoneChange}
                                        inputStyle={{
                                            width: '100%',
                                            height: '48px',
                                            borderRadius: '12px',
                                            border: '1px solid #E5E7EB',
                                            fontFamily: 'Inter',
                                            fontSize: '14px',
                                            paddingLeft: '48px'
                                        }}
                                        containerStyle={{
                                            width: '100%'
                                        }}
                                        buttonStyle={{
                                            borderRadius: '12px 0 0 12px',
                                            border: '1px solid #E5E7EB',
                                            background: '#fff',
                                            padding: '0 8px'
                                        }}
                                    />
                                    {errors.phone && <span className="error-text" style={{ marginTop: '4px' }}>{errors.phone}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Country *</label>
                                    <div className="select-wrapper">
                                        <select name="country" value={formData.country} onChange={handleInputChange}>
                                            <option value="" disabled>Select Country</option>
                                            {countries.map((c) => (
                                                <option key={c.code} value={c.code}>{c.name}</option>
                                            ))}
                                        </select>
                                        <span className="select-icon">{CHEVRON_DOWN_ICON}</span>
                                    </div>
                                    {errors.country && <span className="error-text">{errors.country}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Enquiry Type</label>
                                    <div className="select-wrapper">
                                        <select name="enquiryType" value={formData.enquiryType} onChange={handleInputChange}>
                                            <option value="" disabled>Select Enquiry Type</option>
                                            <option value="intermediates">Intermediates</option>
                                            <option value="api">API</option>
                                            <option value="human_health">Human Health</option>
                                            <option value="animal_health">Animal Health</option>
                                            <option value="cdmo">CDMO & Capabilities</option>
                                            <option value="others">Others</option>
                                        </select>
                                        <span className="select-icon">{CHEVRON_DOWN_ICON}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group full-width">
                                <label>Subject</label>
                                <input type="text" name="subject" value={formData.subject} onChange={handleInputChange} placeholder="Brief subject of your enquiry" />
                            </div>

                            <div className="form-group full-width">
                                <label>Message *</label>
                                <textarea name="message" value={formData.message} onChange={handleInputChange} placeholder="Describe your enquiry in detail..."></textarea>
                                {errors.message && <span className="error-text">{errors.message}</span>}
                            </div>

                            <div className="form-group full-width">
                                <label>Attach Document <span className="label-optional">(Optional — PDF / DOC / DOCX)</span></label>
                                <div className="file-upload-box">
                                    <div className="upload-icon-wrapper">
                                        {UPLOAD_ICON}
                                    </div>
                                    <p className="upload-text">
                                        {fileName ? fileName : <>Drag & drop or <span className="browse-link">browse file</span></>}
                                    </p>
                                    <input type="file" className="hidden-file-input" onChange={handleFileChange} accept=".pdf,.doc,.docx" />
                                </div>
                                {errors.document && <span className="error-text" style={{ marginTop: '8px' }}>{errors.document}</span>}
                            </div>

                            <div className="privacy-consent-box">
                                <p>
                                    I agree to the <Link to="/privacy-policy" className="privacy-link">Privacy Policy</Link> and consent to Viyash Scientific Limited processing my data for the purpose of responding to this enquiry. Data will not be shared with third parties without consent.
                                </p>
                            </div>

                            <button type="submit" className="form-submit-btn" disabled={formStatus !== "idle"}>
                                {formStatus === "submitting" ? "Submitting..." : formStatus === "success" ? "Enquiry Sent! ✓" : <>Submit Enquiry {ARROW_RIGHT}</>}
                            </button>

                            <p className="form-footer-note">
                                Our team responds to all enquiries within 1-2 business days.
                            </p>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Contact;
